/** @format */

export const react = [
  {
    title: 'Модуль 1 - Компоненты и коллекции',
    path: '/react/1',
    items: [
      { title: 'Веб-приложения', path: '/react/1/1' },
      { title: 'React', path: '/react/1/2' },
      { title: 'Browser DOM и Virtual DOM', path: '/react/1/3' },
      { title: 'Инструменты', path: '/react/1/4' },
      { title: 'React-элементы', path: '/react/1/5' },
      { title: 'JavaScript Syntax Extension (JSX)', path: '/react/1/6' },
      { title: 'Компоненты', path: '/react/1/7' },
      { title: 'Свойства компонента (props)', path: '/react/1/8' },
      { title: 'Рендер по условию', path: '/react/1/9' },
      { title: 'Коллекции', path: '/react/1/10' },
      { title: 'Алгоритм обновления DOM', path: '/react/1/11' },
    ],
  },
  {
    title: 'Модуль 2 - Стилизация',
    path: '/react/2',
    items: [
      { title: 'Инлайн CSS', path: '/react/2/1' },
      { title: 'Ванильный CSS или SASS', path: '/react/2/2' },
      { title: 'CSS-модули', path: '/react/2/3' },
      { title: 'CSS-in-JS', path: '/react/2/4' },
      { title: 'Библиотеки компонентов', path: '/react/2/5' },
    ],
  },
  {
    title: 'Модуль 3 - События и состояние',
    path: '/react/3',
    items: [
      { title: 'Компоненты-классы', path: '/react/3/1' },
      { title: 'События', path: '/react/3/2' },
      { title: 'Внутреннее состояние компонента', path: '/react/3/3' },
      { title: 'Типы внутренних данных компонента', path: '/react/3/4' },
    ],
  },
  {
    title: 'Модуль 4 - Жизненный цикл',
    path: '/react/4',
    items: [
      { title: 'Жизненный цикл компонента', path: '/react/4/1' },
      { title: 'Стадия монтирования', path: '/react/4/2' },
      { title: 'Стадия обновления', path: '/react/4/3' },
      { title: 'Стадия размонтирования', path: '/react/4/4' },
      { title: 'Обработка ошибок рендера', path: '/react/4/5' },
    ],
  },
  {
    title: 'Модуль 5 - Формы',
    path: '/react/5',
    items: [
      { title: 'Контролируемый элемент', path: '/react/5/1' },
      { title: 'Формы', path: '/react/5/2' },
      { title: 'Генерация Id элементов формы', path: '/react/5/3' },
      { title: 'Чекбоксы', path: '/react/5/4' },
      { title: 'Радиокнопки', path: '/react/5/5' },
      { title: 'Селект', path: '/react/5/6' },
    ],
  },
  {
    title: 'Модуль 6 - Работа с REST API',
    path: '/react/6',
    items: [
      { title: 'Работа с REST API', path: '/react/6/1' },
      { title: 'Индикатор загрузки', path: '/react/6/2' },
      { title: 'Обработка ошибки', path: '/react/6/3' },
      { title: 'Разделение отвественности', path: '/react/6/4' },
    ],
  },
  {
    title: 'Модуль 7 - React Router',
    path: '/react/7',
    items: [
      { title: 'Маршрутизация', path: '/react/7/1' },
      { title: 'React Router', path: '/react/7/2' },
      { title: 'Строка запроса', path: '/react/7/3' },
      { title: 'Редиректы', path: '/react/7/4' },
    ],
  },
  {
    title: 'Модуль 8 - Code splitting',
    path: '/react/8',
    items: [
      { title: 'Code splitting', path: '/react/8/1' },
      { title: 'Route-based и Component-based splitting', path: '/react/8/2' },
      { title: 'React Loadable', path: '/react/8/3' },
      { title: 'React.lazy версии 16.6+', path: '/react/8/4' },
    ],
  },
  {
    title: 'Модуль 9 - Паттерны и контекст',
    path: '/react/9',
    items: [
      { title: 'Паттерны', path: '/react/9/1' },
      { title: 'Context API', path: '/react/9/2' },
    ],
  },
  {
    title: 'Модуль 10 - Анимация',
    path: '/react/10',
    items: [
      { title: 'Ванильный CSS', path: '/react/10/1' },
      { title: 'React Transition Group', path: '/react/10/2' },
      { title: 'Анимация маршрутов', path: '/react/10/3' },
    ],
  },
]
